import PropTypes from 'prop-types';
import React from 'react';
import s from './WorkTracker.module.scss';
import { STATUSES } from './lib/sorting';

// The pill-shaped status dropdown: the only way a task changes status.
export default function StatusSelect({
  value, onChange, label, className,
}) {
  return (
    <select
      className={`${s.status} ${className || ''}`}
      data-status={value}
      value={value}
      aria-label={label}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => onChange(e.target.value)}
    >
      {STATUSES.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  );
}

StatusSelect.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
};
StatusSelect.defaultProps = { className: '' };
